<p>playlist-menu works!</p>
